/**
 * Converts a string to titlecase.
 *
 * @export
 * @param {any} string The string to convert.
 * @returns the string, with the first letter of each word capitalized.
 */
export function titleCase (string) {
  if (!string) {
    return undefined
  }
  return string.toLowerCase().replace(/\b\S/g, function (t) {
    return t.toUpperCase()
  })
}
